<template>
  <highcharts v-if="loaded" :options="chartOptions"></highcharts>
</template>

<script>
import GraficosService from "@/services/GraficosService";
import "dayjs/locale/pt";

export default {
  name: "ImobilizadoUltimoMesTipologiaPie",

  data() {
    return {
      fireData: [],
    };
  },
  mounted() {
    this.getDadosDashboard();
  },
  computed: {
    loaded: function() {
      return this.fireData != null && this.fireData.length != 0;
    },
    chartOptions: function() {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          size: "100%",
          style: {
            fontFamily: "muli",
          },
          height: 263,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
          align: "left",
        },
        tooltip: {
          pointFormat: "<b>R$ {point.y} ({point.percentage:.1f}%)</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            name: "Tipologia",
            colorByPoint: true,
            data: this.fillPieData(),
          },
        ],
      };
    },
  },
  methods: {
    getDadosDashboard() {
      return GraficosService.getDadosByNome(
        "Firebase - Imobilizado Tipologia Ultimo Mes BRR REPORT"
      )
        .then(({ data }) => {
          this.fireData = Object.values(data.dados);
        })
        .catch((err) => {
          this.$toast.error("Erro ao buscar os dados do Dashboard", "", {
            position: "topRight",
          });
          console.error(err);
        });
    },
    fillPieData: function() {
      var array = [];
      var aux = Object.values(this.fireData);

      var colors = ["#F8A23E", "#F19143", "#FF773D", "#F66448", "#E5502C"];

      var i = 0;
      aux.forEach(function(element, index) {
        array[index] = {
          name: element.name || element.TIPO,
          y: parseFloat(element.y),
          color: colors[i],
        };
        i++;
      });
      return array;
    },
  },
};
</script>
